
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.182 10.182C20.182 16.546 12 22 12 22s-8.182-5.454-8.182-11.818a8.182 8.182 0 0116.364 0z","stroke":"currentColor","stroke-width":"1.4","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M14 8l-4 4M10 8l4 4","stroke":"currentColor","stroke-width":"1.4","stroke-linecap":"round"}})])
          )
        }
      }
    